import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionIdleService } from 'app/services/session-idle.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  countdown = 60;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    private session_idle_service: SessionIdleService
  ) {}

  ngOnInit(): void {
    this.session_idle_service.count_down$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count: number) => {
        this.countdown = count;
      });
  }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.complete();
  }

  onStayLoggedIn(): void {
    this.session_idle_service.extend_session();
    this.dialogRef.close();
  }
}
